import { useState, useEffect } from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { resetPasswordPost } from "../api";

export function ResetPasswordModal({ show, onClose }) {
  const { t } = useTranslation();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (show) {
      setUsername("");
      setEmail("");
      setError("");
      setSuccess(false);
    }
  }, [show]);

  const handleSend = async () => {
    if (!username || !email) {
      setError(t("FillAllFields", "Täytä kaikki kentät"));
      return;
    }

    setError("");

    try {
      const response = await resetPasswordPost({
        username,
        email,
      });

      console.log("Response:", response);

      setSuccess(true);
    } catch (e) {
      console.error(e);
      setError(t("PasswordResetFailed", "Salasanan palautus epäonnistui."));
    }
  };

  return (
    <>
      {show && (
        <Modal show onHide={onClose} backdrop="static" size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>{t("ResetPassword", "Reset Password")}</Modal.Title>
          </Modal.Header>

          <Modal.Body className="h-100" style={{ minHeight: "70vh" }}>
            {success ? (
              <div className="d-flex flex-column justify-content-center align-items-center h-100 text-center">
                <img
                  src="/passwordreset-sent.png"
                  alt="Success"
                  style={{ maxWidth: "25%", marginBottom: "3rem" }}
                /> 
                <h4>{t("ResetLinkSent", "Salasananvaihtolinkki lähetetty onnistuneesti!")}</h4>
                <p>{t("ResetLinkInfo", "Saat kohta sähköpostin, jossa olevaa linkkiä klikkaamalla voit asettaa uuden salasanan. Muista tarkistaa roskapostikansio.")}</p>
              </div>
            ) : (
              <Row className="h-100">
                <Col md={6} className="d-flex flex-column justify-content-center px-5">
                  <div
                    className="w-100"
                    style={{ maxWidth: "400px", margin: "0 auto" }}
                  >
                    <h4 className="mb-4">{t("FillInfo", "Täytä tietosi")}</h4>

                    <Form.Group className="mb-3">
                      <Form.Label>{t("Username", "Käyttäjätunnus")}</Form.Label>
                      <Form.Control
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>{t("Email", "Sähköpostiosoite")}</Form.Label>
                      <Form.Control
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>

                    {error && <div className="text-danger mb-3">{error}</div>}

                    <div className="d-flex mt-2">
                      <Button variant="primary" onClick={handleSend}>
                        {t("SendResetLink", "Lähetä salasananvaihtolinkki")}
                      </Button>
                    </div>
                  </div>
                </Col>

                <Col
                  md={6}
                  className="d-none d-md-flex align-items-center justify-content-center"
                  style={{ backgroundColor: "#f5f6fa" }}
                >
                  <div className="w-100 h-100 d-flex align-items-center justify-content-center p-4">
                    <img
                      src="/passwordreset.png"
                      alt="Reset password"
                      className="img-fluid"
                      style={{ maxHeight: "80%" }}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}